// @flow
import React, {Component} from 'react';

export type Props = {
    className: string,
    vertical: boolean,
    offset: number,
    style: Object,
    disabled: boolean,
    min: number,
    max: number,
    value: ?number,
    index: number,
    dragging?: number,
    prefixCls?: string,
    onSetActiveHandle?: (index: ?number) => void
};

export default class SliderHandle extends Component<Props> {
    handle: {current: null | HTMLDivElement} = React.createRef();

    // start rc-slider uses clickFocus and focus to control focus on handle
    clickFocus = () => {
        this.focus();
    };

    focus = () => {
        if (this.handle.current) {
            this.handle.current.focus();
        }
    };

    blur = () => {
        if (this.handle.current) {
            this.handle.current.blur();
        }
    };
    // end rc-slider uses clickFocus and focus to control focus on handle

    handleBlur = (event: SyntheticEvent<HTMLInputElement>) => {
        const {onSetActiveHandle} = this.props;

        if (onSetActiveHandle) {
            onSetActiveHandle(null);
        }

        event.stopPropagation();
    };

    onBecomeActive = () => {
        const {index, onSetActiveHandle} = this.props;

        this.focus();

        if (onSetActiveHandle) {
            onSetActiveHandle(index);
        }
    };

    render() {
        const {
            className,
            vertical,
            offset,
            style,
            disabled,
            min,
            max,
            value,
            index,
            ...restProps
        } = this.props;

        // we don't need this prop, but rc-slider wants you to pass the rest of the props
        // as html attributes on your slider div
        delete restProps.dragging;
        delete restProps.prefixCls;
        delete restProps.onSetActiveHandle;

        const postionStyle = vertical
            ? {bottom: `${offset}%`}
            : {left: `${offset}%`};
        const elStyle = {
            ...style,
            ...postionStyle
        };

        return (
            <div
                className={`rc-slider-handle-target rc-slider-handle-target-${index}`}
                ref={this.handle}
                role="slider"
                tabIndex="0"
                key={index}
                data-wdio={`rc-slider-handle-target-${index}`}
                aria-valuemin={min}
                aria-valuemax={max}
                aria-valuenow={value || 0}
                aria-disabled={!!disabled}
                {...restProps}
                style={elStyle}
                onMouseDown={this.onBecomeActive}
                onTouchStart={this.onBecomeActive}
                onFocus={this.onBecomeActive}
                onBlur={this.handleBlur}
            >
                <div className={className} />
            </div>
        );
    }
}
